import { useCallback, useState } from 'react';
import { FillQuestionnaireDialog } from './FillQuestionnaireDialog';

export const useFillQuestionnaireDialog = () => {
  const [show, setShow] = useState(false);
  const [resolvePromise, setResolvePromise] = useState(() => (accepted: boolean) => {});

  const showFillQuestionnaireDialog = useCallback(() => {
    return new Promise<boolean>((resolve) => {
      setShow(true);
      setResolvePromise(() => resolve);
    });
  }, []);

  const hideFillQuestionnaireDialog = useCallback(
    (accepted: boolean) => {
      setShow(false);
      resolvePromise(accepted);
    },
    [resolvePromise]
  );

  const _FillQuestionnaireDialog = useCallback(
    () => <FillQuestionnaireDialog show={show} onHide={hideFillQuestionnaireDialog} />,
    [show, hideFillQuestionnaireDialog]
  );

  return {
    showFillQuestionnaireDialog,
    hideFillQuestionnaireDialog,
    FillQuestionnaireDialog: _FillQuestionnaireDialog,
  };
};
